import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import {InboundSettings} from '../../inbound/inbound-settings';

import {useGetInboundFacebookRules, useUpdateInboundFacebookRules} from '../graphql/hooks';

export function SettingsWrapper() {
    const {
        inboundFacebookRules,
        isLoading: isLoadingFacebookRules,
        refetch,
    } = useGetInboundFacebookRules('MESSENGER');

    const {updateInboundFacebookRules} = useUpdateInboundFacebookRules('MESSENGER');

    if (isLoadingFacebookRules) {
        return null;
    }

    return (
        <>
            <div className='py-24'>
                <StackLegacy spacing={8}>
                    <Body isBold={true} size='large'>
                        Configure inbound Facebook and Instagram message handling
                    </Body>
                    <Body>
                        Manage how first-time inbound messages are assigned and create new leads.
                        Use the settings below to streamline communication and keep your team
                        responsive and organized.
                    </Body>
                </StackLegacy>
            </div>
            <InboundSettings
                inboundRules={inboundFacebookRules}
                // @ts-expect-error
                updateInboundRules={updateInboundFacebookRules}
                refetch={refetch}
                isEnrolled={true}
                threadType='MESSENGER'
            />
        </>
    );
}
